import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';
import { ErrorIcon } from './assets/ErrorIcon';

export type GroupingErrorType = 'something-went-wrong' | 'ai-disabled';
export interface GroupingErrorProps {
  onGoBack?: () => void;
  onClick: () => void;
  buttonText: string;
  errorType: GroupingErrorType;
}

export const GroupingError = ({
  onGoBack,
  onClick,
  buttonText,
  errorType,
}: GroupingErrorProps) => {
  const translate = useTranslations('presenting.legacy');

  return (
    <Box
      p={5}
      bg="bgStrong"
      borderRadius="40px"
      m="auto"
      flexDirection="column"
      alignItems="center"
    >
      <ErrorIcon />
      {errorType === 'ai-disabled' ? (
        <>
          <Text color="text" fontWeight="semiBold" fontSize={6} my={2}>
            {translate('open.ai_unavailable')}
          </Text>
          <Text color="text" fontSize={5} my={2} textAlign="center">
            {translate('open.ai_no_access')}
            <br />
            {translate('open.contact_support')}
          </Text>
        </>
      ) : (
        <>
          <Box my={3}>
            <Text color="text" fontWeight="semiBold" fontSize={6}>
              {translate('open.unknown_error')}
            </Text>
          </Box>

          <Box>
            <Button
              px={3}
              py={2}
              variant="primary"
              onClick={onClick}
              extend={() => ({ height: 'unset' })}
              size="large"
            >
              {buttonText}
            </Button>
          </Box>
        </>
      )}
      <Clickable pt={5} onClick={onGoBack}>
        <Text fontSize={3} fontWeight="semiBold" color="primary">
          {translate('open.go_back_to_responses')}
        </Text>
      </Clickable>
    </Box>
  );
};
